// Open UpCart (the store's slide-out cart) so shoppers can edit quantities before checkout.
// Only plain /checkout destinations are swapped; anything else (a Loop bundle URL) still navigates.
window.roneOpenCartOr = window.roneOpenCartOr || async function (url) {
  if (typeof window.upcartOpenCart !== 'function' || !/^\/checkout(\?|$)/.test(url)) {
    window.location.href = url;
    return;
  }
  const code = new URL(url, window.location.origin).searchParams.get('discount');
  if (code) {
    try {
      await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' });
    } catch (error) {}
  }
  if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
  window.upcartOpenCart();
};

/*
 * RONE Product Hero — behavior for the client-approved PDP mockup, wired to
 * real product/selling-plan data instead of the mockup's hardcoded numbers.
 * Three independent custom elements: gallery nav, the nutrition-facts
 * flavor dropdown, and the bundle/flavor/frequency/CTA builder.
 */
(function () {
  // Every network call the one-time (Loop Bundle) flow makes below is
  // otherwise unbounded — under real load a slow response would leave the
  // CTA stuck on "Applying discount…"/"Adding…" forever. Aborting after
  // FETCH_TIMEOUT_MS turns a hang into a normal failure the existing
  // try/catch paths already handle. Mirrors rone-onetime-builder.js.
  const FETCH_TIMEOUT_MS = 8000;
  const fetchWithTimeout = (url, options) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    return fetch(url, { ...options, signal: controller.signal }).finally(() => window.clearTimeout(timer));
  };

  // Perk lines that carry a live discount token. Deliberately un-global (no
  // /g): a /g regex keeps lastIndex between .test() calls, so a shared one
  // would skip every other match when filtering a list.
  const PERK_PCT_TOKEN = /\{(?:pct|renewal_pct)\}/;

  // Single shared toast, reused across every add-to-cart failure on the
  // page — slides up from the bottom, auto-hides after 2s. Lives at
  // document.body rather than inside any one custom element so it isn't
  // clipped by the section's own layout/overflow.
  const showRoneToast = (message) => {
    let toast = document.querySelector('.rone-pdp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'rone-pdp-toast';
      toast.setAttribute('role', 'alert');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    window.clearTimeout(toast._hideTimer);
    toast._hideTimer = window.setTimeout(() => toast.classList.remove('show'), 2000);
  };

  // No single font-size scale can guarantee every freq-perks line (merchant-
  // editable text, so length isn't fixed) fits its two-per-row column at
  // every viewport — rather than wrap to a second line or truncate with an
  // ellipsis, this measures each list's own four items and shrinks them
  // all, in lockstep, down to the largest size at which every one still
  // fits on one line. Lockstep (not per-item) keeps the four lines the
  // same size instead of some looking bigger than others.
  const fitFreqPerksText = () => {
    document.querySelectorAll('.rone-pdp .freq-perks').forEach((list) => {
      const items = Array.from(list.querySelectorAll('.freq-perks__text'));
      if (!items.length) return;

      items.forEach((el) => { el.style.fontSize = ''; });
      let size = Math.max(...items.map((el) => parseFloat(window.getComputedStyle(el).fontSize)));
      const MIN_SIZE = 7;
      const allFit = () => items.every((el) => el.scrollWidth <= el.clientWidth + 0.5);

      while (!allFit() && size > MIN_SIZE) {
        size -= 0.5;
        items.forEach((el) => { el.style.fontSize = size + 'px'; });
      }
    });
  };
  // This script is loaded with `defer`, so the DOM is already parsed by the
  // time it runs — no need to wait for DOMContentLoaded. What it DOES need
  // to wait for is web fonts: Archivo/Big Shoulders Display load with
  // font-display:swap, so an initial fit measured against the fallback
  // system font can under-shrink, then overflow once the real (often
  // wider) font swaps in. document.fonts.ready re-measures once that
  // swap has actually happened.
  fitFreqPerksText();
  if (window.document.fonts && window.document.fonts.ready) {
    window.document.fonts.ready.then(fitFreqPerksText).catch(() => {});
  }
  let freqPerksResizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(freqPerksResizeTimer);
    freqPerksResizeTimer = window.setTimeout(fitFreqPerksText, 120);
  });

  if (!customElements.get('rone-pdp-gallery')) {
    customElements.define(
      'rone-pdp-gallery',
      class RonePdpGallery extends HTMLElement {
        connectedCallback() {
          this.thumbs = Array.from(this.querySelectorAll('[data-g-thumb]'));
          this.img = this.querySelector('[data-g-img]');
          this.dot = this.querySelector('[data-g-dot]');
          this.prev = this.querySelector('[data-g-prev]');
          this.next = this.querySelector('[data-g-next]');
          this.i = 0;

          this.thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => this.show(index));
          });
          if (this.prev) this.prev.addEventListener('click', () => this.show(this.i - 1));
          if (this.next) this.next.addEventListener('click', () => this.show(this.i + 1));
        }

        show(index) {
          if (!this.thumbs.length) return;
          this.i = Math.max(0, Math.min(this.thumbs.length - 1, index));
          const thumb = this.thumbs[this.i];
          if (this.img && this.img.tagName === 'IMG') {
            this.img.src = thumb.dataset.src;
            this.img.alt = thumb.dataset.alt || this.img.alt;
          }
          this.thumbs.forEach((t, x) => t.classList.toggle('on', x === this.i));
          if (this.dot) this.dot.textContent = (this.i + 1) + ' / ' + this.thumbs.length;
          if (this.prev) this.prev.disabled = this.i === 0;
          if (this.next) this.next.disabled = this.i === this.thumbs.length - 1;
        }
      }
    );
  }

  if (!customElements.get('rone-pdp-nutrition')) {
    customElements.define(
      'rone-pdp-nutrition',
      class RonePdpNutrition extends HTMLElement {
        connectedCallback() {
          this.dd = this.querySelector('[data-nb-dd]');
          this.btn = this.querySelector('[data-nb-dd-btn]');
          this.list = this.querySelector('[data-nb-dd-list]');
          this.label = this.querySelector('[data-nb-dd-label]');
          this.panels = Array.from(this.querySelectorAll('[data-nb-panel]'));

          if (!this.btn || !this.list) return;

          this.btn.addEventListener('click', (event) => {
            event.stopPropagation();
            const opening = this.list.hidden;
            this.list.hidden = !opening;
            this.dd.classList.toggle('open', opening);
            this.btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
          });

          this.list.addEventListener('click', (event) => {
            const opt = event.target.closest('[data-nb-dd-opt]');
            if (!opt) return;
            const key = opt.dataset.f;
            if (this.label) this.label.textContent = opt.textContent.trim();
            this.list.querySelectorAll('[data-nb-dd-opt]').forEach((o) => o.classList.toggle('sel', o === opt));
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.f !== key;
            });
            this.close();
          });

          this.close = this.close.bind(this);
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) this.close();
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
          });
        }

        close() {
          if (!this.list || this.list.hidden) return;
          this.list.hidden = true;
          this.dd.classList.remove('open');
          this.btn.setAttribute('aria-expanded', 'false');
        }
      }
    );
  }

  if (!customElements.get('rone-product-builder')) {
    customElements.define(
      'rone-product-builder',
      class RoneProductBuilder extends HTMLElement {
        connectedCallback() {
          this.msrp = parseFloat(this.dataset.msrp || '0');
          this.priceLadder = JSON.parse(this.dataset.priceLadder || '{}');
          this.renewalPriceLadder = JSON.parse(this.dataset.renewalPriceLadder || '{}');
          this.cadenceLadder = JSON.parse(this.dataset.cadenceLadder || '{}');
          this.sellingPlans = JSON.parse(this.dataset.sellingPlans || '{}');
          this.discountCode = this.dataset.discountCode || '';
          this.mode = 'sub';
          this.picks = {};
          this.cartAdding = false;
          this.cartAdded = false;

          // One-time purchases go through a real Loop Bundle transaction
          // (see createBundleTransaction/loadBundle below) so its quantity
          // discounts are genuine, not a made-up ladder — mirrors
          // rone-onetime-builder.js. sellingPlanShopifyId stays null for
          // this transaction (Loop's own docs: "null for one-time") so a
          // one-time buyer is never silently enrolled in a subscription.
          this.bundleId = this.dataset.bundleId || '';
          this.shopDomain = this.dataset.shopDomain || '';
          this.discounts = [];
          this.boxSizeId = '';
          this.redirectionUrl = '/checkout';
          this.resolvedBundleId = '';

          this.rows = Array.from(this.querySelectorAll('[data-frow]'));
          // Cheapest available row is the one-time "from" baseline — it drives
          // both the quantity-ladder preview and the One-time row's own price
          // before any bag is picked. Its compare-at rides along so the row can
          // strike through a real was-price the same way the Subscribe row does.
          let onceBaseRow = null;
          this.rows.forEach((row) => {
            const price = parseFloat(row.dataset.price || '0') / 100;
            if (price > 0 && (!onceBaseRow || price < onceBaseRow.price)) {
              onceBaseRow = { price, compare: parseFloat(row.dataset.compareAt || '0') / 100 };
            }
          });
          this.onceBasePrice = onceBaseRow ? onceBaseRow.price : 0;
          this.onceCompareBase = onceBaseRow ? Math.max(onceBaseRow.compare, onceBaseRow.price) : 0;

          this.qFill = this.querySelector('[data-q-fill]');
          this.qNodes = Array.from(this.querySelectorAll('[data-q-node]'));
          this.fqSub = this.querySelector('[data-fq-sub]');
          this.fqOnce = this.querySelector('[data-fq-once]');
          this.subFlag = this.querySelector('[data-sub-flag]');
          this.cycleDays = this.querySelector('[data-cycle-days]');
          this.subWas = this.querySelector('[data-sub-was]');
          this.subEach = this.querySelector('[data-sub-each]');
          this.onceEach = this.querySelector('[data-once-each]');
          this.onceWas = this.querySelector('[data-once-was]');
          this.onceSuffix = this.querySelector('[data-once-suffix]');
          this.sumRow = this.querySelector('[data-sum-row]');
          this.savePct = this.querySelector('[data-save-pct]');
          this.bagCount = this.querySelector('[data-bag-count]');
          this.cta = this.querySelector('[data-cta-link]');
          this.ctaLabel = this.querySelector('[data-cta-label]');
          this.ctaPriceWrap = this.querySelector('[data-cta-price]');
          this.ctaWas = this.querySelector('[data-cta-was]');
          this.ctaNow = this.querySelector('[data-cta-now]');
          this.stickyBar = this.querySelector('[data-sticky-bar]');
          this.stickyNote = this.querySelector('[data-sticky-note]');
          this.stickyCta = this.querySelector('[data-sticky-cta]');
          this.stickyLabel = this.querySelector('[data-sticky-label]');

          // Perk lines can opt into a live discount % via two tokens: {pct}
          // for the first-order discount (the same number shown in the
          // "Save X% on first order" badge, data-sub-flag) and {renewal_pct}
          // for the ongoing discount billed on future orders, off the
          // renewal ladder. Single braces — Shopify's JSON templates treat
          // {{ }} in a setting value as a "dynamic source" binding and reject
          // anything that isn't one, so {{pct}} fails theme upload/validation.
          // The section already substituted both for the first paint, so the
          // pristine template is read from data-perk-template (falling back to
          // the markup itself) — substituting off the rendered text would
          // compound on the next render.
          this.perkPctEls = Array.from(this.querySelectorAll('.freq-perks__text'))
            .map((el) => ({ el, template: el.dataset.perkTemplate || el.innerHTML }))
            .filter(({ template }) => PERK_PCT_TOKEN.test(template));

          this.rows.forEach((row) => {
            const variantId = row.dataset.variantId;
            row.querySelector('[data-f-add]').addEventListener('click', () => this.adjust(variantId, 1));
            row.querySelector('[data-f-inc]').addEventListener('click', () => this.adjust(variantId, 1));
            row.querySelector('[data-f-dec]').addEventListener('click', () => this.adjust(variantId, -1));
          });

          // Restore whatever was picked (and which frequency tab was open)
          // before the shopper left for checkout — so a browser-back
          // landing here reproduces their exact selection instead of the
          // default empty/Subscribe state.
          this.readStateFromURL();

          this.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.addEventListener('change', () => {
              this.setMode(input.value === 'once' ? 'once' : 'sub');
            });
          });

          // Belt-and-suspenders on top of the `change` listener above: the
          // radio's own `checked` state can lag a tick behind a freshly
          // upgraded custom element (the input's native click-forwarding
          // from its wrapping <label> doesn't reliably fire `change` on the
          // very first tap right after connectedCallback runs), which is
          // what made the first click on "One-time Purchase" appear to do
          // nothing until a second toggle. Handling the label's own click
          // directly and forcing `checked` guarantees the very first tap
          // always switches modes; setMode() below is a no-op if the mode
          // didn't actually change, so a `change` event firing too (now or
          // later) never double-applies this.
          [this.fqSub, this.fqOnce].forEach((label) => {
            if (!label) return;
            label.addEventListener('click', () => {
              const input = label.querySelector('input[type="radio"]');
              if (!input) return;
              input.checked = true;
              this.setMode(input.value === 'once' ? 'once' : 'sub');
            });
          });

          if (this.cta) {
            this.cta.addEventListener('click', (event) => {
              event.preventDefault();
              if (this.cta.classList.contains('cta--disabled') || this.cartAdding || this.cartAdded) return;
              this.addToCart();
            });
          }

          // Mirrors the main CTA's own click guard/action — the sticky bar
          // is just another entry point into the same addToCart() flow.
          if (this.stickyCta) {
            this.stickyCta.addEventListener('click', (event) => {
              event.preventDefault();
              if (this.stickyCta.classList.contains('cta--disabled') || this.cartAdding || this.cartAdded) return;
              this.addToCart();
            });
          }

          // Reveals the sticky bar once the real add-to-cart button has
          // scrolled out of view — mobile only (hidden by CSS above 980px).
          if (this.cta && this.stickyBar && 'IntersectionObserver' in window) {
            new IntersectionObserver(([entry]) => {
              this.stickyBar.classList.toggle('show', !entry.isIntersecting);
            }, { threshold: 0 }).observe(this.cta);
          }

          // Starts every fresh visit to this page from an empty cart, same
          // reasoning as the clear on toggle above — a stale line item from
          // an earlier visit/mode must never mix with what's added here.
          this.clearCart();

          this.render();
          this.bundleLoadPromise = this.loadBundle();
          this.suppressCartDrawer();
        }

        async resolveBundleId() {
          // data-bundle-id (from the section's schema setting) is trusted
          // directly whenever it's set — only falls back to the List
          // Bundles API when it's left blank.
          if (this.bundleId) return this.bundleId;

          const listUrl = 'https://api.loopsubscriptions.com/storefront/2023-10/bundle'
            + '?myshopifyDomain=' + encodeURIComponent(this.shopDomain);
          const response = await fetchWithTimeout(listUrl, { headers: { Accept: 'application/json' } });
          const data = await response.json();
          const bundles = (data && data.data) || [];
          if (!data || !data.success || !bundles.length) {
            throw new Error('No Loop bundles found for this store');
          }
          return bundles[0].id;
        }

        async loadBundle() {
          if (!this.shopDomain) return;

          try {
            this.resolvedBundleId = await this.resolveBundleId();

            const url = 'https://api.loopsubscriptions.com/storefront/2023-10/bundle/'
              + this.resolvedBundleId + '?myshopifyDomain=' + encodeURIComponent(this.shopDomain);
            const response = await fetchWithTimeout(url, { headers: { Accept: 'application/json' } });
            const data = await response.json();
            const bundle = data && data.data;
            if (!data || !data.success || !bundle) throw new Error('Bad Loop bundle response');

            this.discounts = bundle.discounts || [];
            this.boxSizeId = (bundle.boxSizes && bundle.boxSizes[0] && bundle.boxSizes[0].id) || '';
            this.redirectionUrl = bundle.redirectionUrl || '/checkout';
            this.render();
          } catch (error) {
            console.warn('[rone-product-builder] could not load Loop bundle — one-time checkout will proceed without a discount:', error);
            this.resolvedBundleId = '';
          }
        }

        // Highest quantity-threshold tier the current count qualifies for.
        discountTierFor(n) {
          let best = null;
          this.discounts.forEach((d) => {
            if (d.minCartQuantity <= n && (!best || d.minCartQuantity > best.minCartQuantity)) {
              best = d;
            }
          });
          return best;
        }

        // Tiers aren't guaranteed to share one discount type (percentage vs
        // a flat amount off) — branch on type rather than always reading
        // value as a percent.
        applyTier(rawTotal, tier, itemCount) {
  if (!tier) return rawTotal;
  const value = parseFloat(tier.value) || 0;
  if (tier.type === 'FIXED_AMOUNT' || tier.type === 'FIXED') {
    // Loop = "apply discount on each eligible item", so value is per-item.
    // Scale by qty to mirror what checkout actually deducts.
    return Math.max(0, rawTotal - value * (itemCount || 0));
  }
  return rawTotal * (1 - value / 100);
}

        // POST .../bundle/{id}/transaction — required every time a new
        // bundle is added to the cart (per Loop's docs). productVariants[].
        // quantity is each child variant's own quantity inside the box;
        // top-level `quantity` is the number of *bundles*, which stays 1 for
        // a build-your-own box.
        async createBundleTransaction(tier, productVariants) {
          if (!this.resolvedBundleId || !this.boxSizeId) {
            throw new Error('Loop bundle not loaded');
          }

          const url = 'https://api.loopsubscriptions.com/storefront/2023-10/bundle/'
            + this.resolvedBundleId + '/transaction?myshopifyDomain=' + encodeURIComponent(this.shopDomain);

          const body = {
            boxSizeId: this.boxSizeId,
            sellingPlanShopifyId: null,
            quantity: 1,
            productVariants,
          };
          if (tier && tier.id) body.discountId = tier.id;

          const response = await fetchWithTimeout(url, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (!data || !data.success || !data.data || !data.data.txnId) {
            throw new Error('Could not create Loop bundle transaction');
          }
          return data.data.txnId;
        }

        // Upcart's cart drawer auto-opens on /cart/add.js; this page adds to
        // cart then immediately redirects to checkout, so the drawer must
        // never get a chance to render. Subscribing here (before the
        // shopper can even click add-to-cart) beats the drawer's own open
        // event. Polling is capped — if the app is uninstalled, blocked, or
        // its script fails to load, this must not poll forever.
        suppressCartDrawer() {
          // The header cart icon and the slide-out cart stay available: shoppers
          // edit quantities in the drawer before checkout.

          let attempts = 0;
          const maxAttempts = 100; // ~5s at 50ms
          const trySubscribe = () => {
            if (typeof window.upcartSubscribeCartOpened !== 'function') {
              attempts += 1;
              if (attempts >= maxAttempts) return;
              window.setTimeout(trySubscribe, 50);
              return;
            }
            if (typeof window.upcartSubscribeCartLoaded === 'function') {
              window.upcartSubscribeCartLoaded(() => {
                const stickyBtn = document.querySelector('#upCartStickyButton') || document.getElementById('CartPopup');
                if (stickyBtn) stickyBtn.style.display = 'none';
              });
            }
          };
          trySubscribe();
        }

        // Returns the in-flight request so addToCart() can await it —
        // cart/clear.js must resolve before cart/add.js fires. Errors are
        // swallowed (not rethrown) so a clear failure never blocks the add.
        clearCart() {
          return fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }).catch(() => {});
        }

        // No-op if already in this mode — both the radio's `change` event
        // and the label's own `click` listener can each end up calling
        // this for the same transition, and a cart clear should only ever
        // fire once per actual mode switch.
        setMode(newMode) {
          if (this.mode === newMode) return;
          this.mode = newMode;
          // A leftover line item from the other mode (e.g. a Subscribe add
          // that didn't make it to checkout, then the shopper switched to
          // One-time) must never sit in the cart alongside a
          // different-mode add later — same intent as the old
          // rone-stage-router.js clearing the cart when crossing between
          // subscribe/onetime, triggered here by the toggle itself since
          // this page has no separate stage navigation.
          this.clearCart();
          this.cartAdded = false;
          this.render();
          this.syncURL();
        }

        money(n) {
          return '$' + n.toFixed(2);
        }

        count() {
          return Object.values(this.picks).reduce((sum, n) => sum + n, 0);
        }

        bagWord(n) {
          return n + ' bag' + (n === 1 ? '' : 's');
        }

        updatePerkPct(pct, renewalPct) {
          let changed = false;
          this.perkPctEls.forEach(({ el, template }) => {
            const html = template
              .replace(/\{renewal_pct\}/g, renewalPct)
              .replace(/\{pct\}/g, pct);
            if (el.innerHTML === html) return;
            el.innerHTML = html;
            changed = true;
          });
          // A substituted % can change width ("8%" -> "18%"), which can push a
          // line past the one-line clamp the initial fit sized it for. Only on
          // a real text change — the fit loop reads scrollWidth repeatedly, so
          // running it on every render (each +/- tap) would thrash layout for
          // nothing.
          if (changed) fitFreqPerksText();
        }

        tierFor(qty) {
          return Math.min(Math.max(qty, 1), 4);
        }

        subPriceFor(qty) {
          const tier = this.tierFor(qty);
          return this.priceLadder[tier] || this.priceLadder[4] || 0;
        }

        subRenewalFor(qty) {
          const tier = this.tierFor(qty);
          return this.renewalPriceLadder[tier] || this.renewalPriceLadder[4] || this.subPriceFor(qty);
        }

        subCadenceFor(qty) {
          const tier = this.tierFor(qty);
          return this.cadenceLadder[tier] || this.cadenceLadder[4] || 30;
        }

        // Each row's own real price/compare-at, with Loop's real quantity-tier
        // discount (fetched in loadBundle) applied on top — same live-tier
        // math as rone-onetime-builder.js's preview, just against this
        // component's own picks instead of a simulated node quantity.
        onceTotals() {
          let raw = 0;
          let compare = 0;
          this.rows.forEach((row) => {
            const qty = this.picks[row.dataset.variantId] || 0;
            if (!qty) return;
            const price = parseFloat(row.dataset.price || '0') / 100;
            const compareAt = parseFloat(row.dataset.compareAt || '0') / 100;
            raw += price * qty;
            compare += (compareAt > price ? compareAt : price) * qty;
                    });
          const tier = this.discountTierFor(this.count());
          const total = this.applyTier(raw, tier, this.count());
          return { raw, compare, total };
        }

        adjust(variantId, delta) {
          const next = (this.picks[variantId] || 0) + delta;
          if (next <= 0) delete this.picks[variantId];
          else this.picks[variantId] = next;
          // Picks changed since the cart was last synced — the next
          // checkout click needs to add these before proceeding.
          this.cartAdded = false;
          this.render();
          this.syncURL();
        }

        // ?bags=<variantId>:<qty>,<variantId>:<qty>&mode=sub|once — read on
        // load so a shopper who bounces to checkout and hits back lands on
        // the exact same selection (bags, quantities, and which frequency
        // tab was open) instead of the default empty/Subscribe state. Only
        // variant ids that actually exist on this page are honored, so a
        // hand-edited/stale URL can't smuggle in a pick for a variant that
        // isn't here.
        readStateFromURL() {
          const params = new URLSearchParams(window.location.search);

          const rawBags = params.get('bags');
          if (rawBags) {
            const validIds = new Set(this.rows.map((row) => row.dataset.variantId));
            rawBags.split(',').forEach((pair) => {
              const [id, qtyStr] = pair.split(':');
              const qty = parseInt(qtyStr, 10);
              if (validIds.has(id) && Number.isFinite(qty) && qty > 0) {
                this.picks[id] = qty;
              }
            });
          }

          const rawMode = params.get('mode');
          if (rawMode === 'sub' || rawMode === 'once') {
            this.mode = rawMode;
            const input = this.querySelector('input[type="radio"][value="' + rawMode + '"]');
            if (input) input.checked = true;
          }
        }

        // Mirrors the current picks + mode into the URL (replaceState — no
        // new history entries per +/- click or tab switch) so it survives a
        // reload or a checkout round-trip.
        syncURL() {
          const url = new URL(window.location.href);
          const entries = Object.keys(this.picks)
            .filter((id) => this.picks[id] > 0)
            .map((id) => id + ':' + this.picks[id]);

          if (entries.length) {
            url.searchParams.set('bags', entries.join(','));
          } else {
            url.searchParams.delete('bags');
          }

          url.searchParams.set('mode', this.mode);

          window.history.replaceState(null, '', url);
        }

        updateLadder(n) {
          if (!this.qFill || !this.qNodes.length) return;
          const clamped = Math.min(Math.max(n, 1), 4);
          const fillPct = n === 0 ? 0 : ((clamped - 1) / 3) * 100;
          this.qFill.style.width = fillPct + '%';

          this.qNodes.forEach((node) => {
            const q = parseInt(node.dataset.q, 10);
            node.classList.toggle('q-node--reached', n > 0 && q <= clamped);
            node.classList.toggle('q-node--current', n > 0 && q === clamped);

            const eachEl = node.querySelector('[data-q-each]');
            const offEl = node.querySelector('[data-q-off]');
            if (this.mode === 'sub') {
              const each = this.priceLadder[q] || this.priceLadder[4] || 0;
              const pct = this.msrp > 0 ? Math.round(((this.msrp - each) / this.msrp) * 100) : 0;
              if (eachEl) eachEl.textContent = this.money(each) + '/ea';
              if (offEl) offEl.textContent = pct > 0 ? pct + '% Off' : '';
            } else if (!this.onceBasePrice) {
              if (eachEl) eachEl.textContent = '—';
              if (offEl) offEl.textContent = '';
            } else {
              const rawTotal = this.onceBasePrice * q;
              const tier = this.discountTierFor(q);
              const total = this.applyTier(rawTotal, tier, q);
              const pct = rawTotal > 0 ? Math.round(((rawTotal - total) / rawTotal) * 100) : 0;
              if (eachEl) eachEl.textContent = this.money(total / q) + '/ea';
              if (offEl) offEl.textContent = pct > 0 ? pct + '% Off' : '';
            }
          });
        }

        // Mirrors the main CTA's label/price into the sticky mobile bar's
        // own note + label text — same n/total the main CTA just rendered,
        // just worded for the condensed bar (e.g. "Subscribe · $135.80").
        updateSticky(n, total) {
          if (!this.stickyBar) return;

          if (n === 0) {
            if (this.stickyCta) this.stickyCta.classList.add('cta--disabled');
            if (this.stickyLabel) this.stickyLabel.textContent = 'Build your bundle';
            if (this.stickyNote) this.stickyNote.textContent = '30-day guarantee · free shipping on 2+ bags';
            return;
          }

          if (this.stickyCta) this.stickyCta.classList.remove('cta--disabled');
          if (this.stickyLabel) {
            this.stickyLabel.textContent = (this.mode === 'sub' ? 'Subscribe' : 'Add to Cart') + ' · ' + this.money(total);
          }
          if (this.stickyNote) {
            this.stickyNote.textContent = this.mode === 'sub'
              ? 'Ships every ' + this.subCadenceFor(n) + ' days · free shipping · cancel anytime'
              : '30-day guarantee · ' + (n >= 2 ? 'free shipping' : 'add 1 more bag for free shipping');
          }
        }

        render() {
          const n = this.count();
          this.updateLadder(n);

          this.rows.forEach((row) => {
            const qty = this.picks[row.dataset.variantId] || 0;
            row.querySelector('[data-f-n]').textContent = qty;
            row.classList.toggle('picked', qty > 0);
            row.querySelector('[data-f-add]').classList.toggle('hide', qty > 0);
            row.querySelector('.f-step').classList.toggle('on', qty > 0);
          });

          const previewQty = n || 1;
          const subEach = this.subPriceFor(previewQty);
          if (this.subEach) this.subEach.textContent = this.money(subEach);
          if (this.subWas) this.subWas.textContent = this.money(this.msrp || subEach);
          if (this.cycleDays) this.cycleDays.textContent = this.subCadenceFor(previewQty);
          // The perk lines describe two different moments — today's order and
          // every refill after it — so they need both rates. subRenewalFor()
          // is the post-introductory-cycle price, which a Loop plan can
          // discount more deeply than the first charge.
          const firstPct = this.msrp > 0 ? Math.round(((this.msrp - subEach) / this.msrp) * 100) : 0;
          const subRenewalEach = this.subRenewalFor(previewQty);
          const renewalPct = this.msrp > 0 ? Math.round(((this.msrp - subRenewalEach) / this.msrp) * 100) : 0;
          if (this.subFlag) {
            this.subFlag.textContent = firstPct > 0 ? 'Save ' + firstPct + '% on first order' : 'Subscribe & Save';
          }
          this.updatePerkPct(firstPct, renewalPct);
          // One-time row previews exactly the way the Subscribe row does — at
          // 1 bag while nothing is picked — so both sides of the toggle show a
          // real price on load instead of the once row sitting blank.
          let onceRaw;
          let onceCompare;
          let onceTotal;
          if (n > 0) {
            const totals = this.onceTotals();
            onceRaw = totals.raw;
            onceCompare = totals.compare;
            onceTotal = totals.total;
          } else {
            onceRaw = this.onceBasePrice * previewQty;
            onceCompare = this.onceCompareBase * previewQty;
            onceTotal = this.applyTier(onceRaw, this.discountTierFor(previewQty), previewQty);
          }
          const onceEachPrice = onceTotal / previewQty;
          const onceWasPrice = onceCompare / previewQty;
          if (this.onceEach) {
            this.onceEach.textContent = onceRaw > 0 ? this.money(onceEachPrice) : '';
          }
          if (this.onceWas) {
            // Half a cent of slack — a was-price that rounds to the same string
            // as the now-price would render as "$71.00 $71.00".
            const showOnceWas = onceRaw > 0 && onceWasPrice > onceEachPrice + 0.005;
            this.onceWas.hidden = !showOnceWas;
            if (showOnceWas) this.onceWas.textContent = this.money(onceWasPrice);
          }
          if (this.onceSuffix) this.onceSuffix.hidden = onceRaw <= 0;

          if (this.fqSub) this.fqSub.classList.toggle('on', this.mode === 'sub');
          if (this.fqOnce) this.fqOnce.classList.toggle('on', this.mode === 'once');

          if (n === 0) {
            if (this.sumRow) this.sumRow.hidden = true;
            if (this.cta) this.cta.classList.add('cta--disabled');
            if (this.ctaLabel) this.ctaLabel.textContent = 'Select at least 1 bag';
            if (this.ctaPriceWrap) this.ctaPriceWrap.hidden = true;
            this.updateSticky(0);
            return;
          }

          let total;
          let compareTotal;
          if (this.mode === 'sub') {
            const each = this.subPriceFor(n);
            total = each * n;
            compareTotal = this.msrp * n;
          } else {
            const totals = this.onceTotals();
            total = totals.total;
            compareTotal = totals.compare;
          }
          const pct = compareTotal > 0 ? Math.round(((compareTotal - total) / compareTotal) * 100) : 0;

          if (this.sumRow) this.sumRow.hidden = false;
          if (this.savePct) this.savePct.textContent = pct + '%';
          // if (this.bagCount) this.bagCount.textContent = this.bagWord(n) + ' · ' + this.money(total / n) + '/bag';
           if (this.bagCount) this.bagCount.textContent = this.bagWord(n) +' selected';
          if (this.cta) this.cta.classList.remove('cta--disabled');
          if (this.ctaLabel) this.ctaLabel.textContent = this.mode === 'sub' ? 'Subscribe & Save' : 'Add to Cart';
          if (this.ctaPriceWrap) this.ctaPriceWrap.hidden = false;
          if (this.ctaWas) this.ctaWas.textContent = this.money(compareTotal);
          if (this.ctaNow) this.ctaNow.textContent = this.money(total);

          this.updateSticky(n, total);
        }

        async addToCart() {
          if (this.cartAdding || this.cartAdded) return;
          const n = this.count();
          if (!n) return;
          const mode = this.mode;
          this.cartAdding = true;

          // Always clear whatever's in the cart before adding — regardless
          // of mode or prior picks — so a stale line item from an earlier
          // click/mode never rides along with this add.
          await this.clearCart();

          if (mode === 'sub') {
            await this.addToCartSubscribe(n);
          } else {
            await this.addToCartOnetime(n);
          }
          this.cartAdding = false;
        }

        // Subscribe & Save — same flow as rone-flavor-selector.js: add with
        // the real selling_plan for this tier, then apply the discount code
        // via Shopify's own /discount/:code cookie route before checkout.
        async addToCartSubscribe(n) {
          // Subscribe must always carry its own discount_code (see the
          // checkoutUrl comment below) — if the section setting is ever
          // left blank, a subscriber would land on checkout at full price
          // with no way to fix it themselves, so refuse to proceed instead.
          if (!this.discountCode) {
            showRoneToast('Subscribe checkout is misconfigured — missing discount code.');
            return;
          }

          const sellingPlan = this.sellingPlans[this.tierFor(n)] || '';
          const items = Object.keys(this.picks).map((variantId) => {
            const item = { id: parseInt(variantId, 10), quantity: this.picks[variantId] };
            if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);
            return item;
          });

          if (this.ctaLabel) this.ctaLabel.textContent = 'Adding…';

          try {
            const res = await fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ items }),
            });
            const data = await res.json();
            if (data.status) throw data.description || 'Could not add to cart';
            this.cartAdded = true;

            // Belt-and-suspenders, same as rone-flavor-selector.js: try the
            // /discount/:code cookie route first (sometimes the checkout
            // URL's own ?discount= param alone isn't enough to make it
            // stick), but always still append the query param too rather
            // than making it an either/or — that param is what stays
            // authoritative if a shopper switched over from One-time
            // (whose Loop bundle discount is already active on the
            // checkout session) and the cookie call above can't reliably
            // confirm it replaced that different, already-active discount.
            try {
              await fetchWithTimeout(`/discount/${encodeURIComponent(this.discountCode)}`, {
                method: 'GET',
                credentials: 'same-origin',
                redirect: 'manual',
              });
            } catch (error) {
              console.warn('[rone-product-builder] discount cookie not applied, falling back to checkout URL param:', error);
            }

            await window.roneOpenCartOr('/checkout?discount=' + encodeURIComponent(this.discountCode));
          } catch (error) {
            console.error(typeof error === 'string' ? error : 'Something went wrong adding your bags to cart.');
            if (this.ctaLabel) this.ctaLabel.textContent = 'Subscribe & Save';
            showRoneToast(typeof error === 'string' ? error : 'Something went wrong adding your bags to cart.');
          }
        }

        // One-time purchase — mirrors rone-onetime-builder.js: create a real
        // Loop Bundle transaction first (so its quantity discount is genuine),
        // tag the cart line with the resulting txnId as the _bundleId
        // property (Loop's own linking mechanism), then redirect to the
        // bundle's own redirectionUrl. See
        // https://developer.loopwork.co/reference/create-bundle-transaction
        async addToCartOnetime(n) {
          if (this.ctaLabel) this.ctaLabel.textContent = 'Applying discount…';

          // Waits for the bundle fetch so the box size id / discount tiers
          // matching the final picked quantity are ready before the
          // transaction is created.
          await this.bundleLoadPromise;

          const productVariants = Object.keys(this.picks).map((id) => ({
            shopifyId: parseInt(id, 10),
            quantity: this.picks[id],
          }));
          const tier = this.discountTierFor(n);

          let txnId = '';
          try {
            txnId = await this.createBundleTransaction(tier, productVariants);
          } catch (error) {
            console.warn('[rone-product-builder] could not create Loop bundle transaction — checkout will proceed without a discount:', error);
          }

          const items = Object.keys(this.picks).map((id) => {
            const item = { id: parseInt(id, 10), quantity: this.picks[id] };
            if (txnId) item.properties = { _bundleId: txnId };
            return item;
          });

          if (this.ctaLabel) this.ctaLabel.textContent = 'Adding…';

          try {
            const res = await fetchWithTimeout('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ items }),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw data.description || 'Could not add to cart';
            this.cartAdded = true;

            if (tier && tier.code) {
              try {
                await fetchWithTimeout(`/discount/${encodeURIComponent(tier.code)}`, {
                  method: 'GET',
                  credentials: 'same-origin',
                  redirect: 'manual',
                });
              } catch (error) {
                // A hiccup applying the discount shouldn't block checkout —
                // the items are already in the cart at this point.
                console.warn('[rone-product-builder] discount not applied, proceeding to checkout anyway:', error);
              }
            }

            const checkoutUrl = this.redirectionUrl || '/checkout';
            await window.roneOpenCartOr(checkoutUrl);
          } catch (error) {
            console.error('[rone-product-builder] FAILED:', typeof error === 'string' ? error : error);
            if (this.ctaLabel) this.ctaLabel.textContent = 'Add to Cart';
            showRoneToast(typeof error === 'string' ? error : 'Something went wrong adding your bags to cart.');
          }
        }
      }
    );
  }
})();
